module.exports = {
	BASE_URL: "https://moj-apis.staging.sharechat.com",
	RECAPTCHA_SITE_KEY: "6Lfq5I0aAAAAAEwFSu_GyO98w0s0DD951udoTzQ4"
};
